var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-b-16"},[(_vm.showOrder)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"招标单信息"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.orderInfo,"option":_vm.biddingInfoOption,"el-attrs":{
            size: 'medium',
            column: 3,
            labelStyle: {
              whiteSpace: 'nowrap'
            }
          }},scopedSlots:_vm._u([{key:"budget",fn:function(ref){
          var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value ? _vm.strToThousands(value) : '-')+" 万元")]),_c('money-in-cn',{attrs:{"money":value * 10000}})]}}],null,false,1188641901)})],1)])]):_vm._e(),_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"内容变更"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.changeInfo,"option":_vm.contentOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '130px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }}})],1)])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"变更公告"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.changeInfo,"option":_vm.noticeOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '100px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('u-editor',{attrs:{"disabled":"","value":_vm.changeInfo.content}})]},proxy:true}])})],1)])]),(_vm.requestQuery.pageFrom == 'auditDetail')?_c('record-remark',{attrs:{"remark-list":_vm.remarkList}}):_vm._e(),(_vm.requestQuery.pageFrom == 'auditDetail')?_c('record-history',{attrs:{"record-list":_vm.orderInfo.flowListing}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }